import {utils} from '@wallaby-ui/core';
import {find, findIndex, forEach} from 'lodash';

export type RangeProperty = 'START' | 'END';

export interface FilterValueOptions {
  rangeProperty: RangeProperty;
}

class Filter {
  static getFilterSelectedIdx(filters, filter) {
    return findIndex(filters, (selectedFilter) =>
      selectedFilter.isEqual(filter)
    );
  }

  static isFilterSelected(filters, filter) {
    return Filter.getFilterSelectedIdx(filters, filter) > -1;
  }

  static fromString() {
    return new Filter();
  }

  static fromSchema(schemaNode) {
    return new Filter({property: schemaNode.getName()});
  }

  /* eslint-disable consistent-return */
  static areFilterModelsEqual(first, second) {
    let result = true;
    if (!first && !second) {
      result = true;
    } else if (first && second && first.length !== second.length) {
      result = false;
    } else {
      forEach(first, (firstItem) => {
        const theSameItem = find(second, (secondItem) =>
          Filter.areFilterModelsItemsEqual(firstItem, secondItem)
        );
        if (!theSameItem) {
          result = false;
          return false;
        }
      });
    }
    return result;
  }

  /* eslint-enable consistent-return */

  // we have to use static method instead of instance method filter.isEqualWithValue
  // because "manual filters" defined in ag grid table configuration (filterButtons)
  static areFilterModelsItemsEqual(first, second) {
    return (
      first.property === second.property &&
      first.type === second.type &&
      ((Object.prototype.hasOwnProperty.call(first, 'value') &&
        first.value === second.value) ||
        (Object.prototype.hasOwnProperty.call(first, 'filter') &&
          first.filter === second.filter))
    );
  }

  constructor(filterData) {
    if (filterData) {
      this.type = filterData.type;
      this.property = filterData.property;
      this.value = filterData.value;
    }
    this.id = utils.generateGUID();
  }

  clone() {
    return new Filter({
      type: this.type,
      property: this.property,
      value: {...this.value},
      id: this.id,
    });
  }

  isEqual(otherFilter) {
    return this.property === otherFilter.property;
  }

  isEqualWithValue(otherFilter) {
    return (
      this.property === otherFilter.property &&
      this.type === otherFilter.type &&
      this.value === otherFilter.value
    );
  }

  getProperty() {
    return this.property;
  }

  getValueToString(_options?: FilterValueOptions) {
    const value = this.getValue();
    if (value != null) {
      return `${value}`;
    }
    return undefined;
  }

  getRangeProperties(_filterSchema): string[] | undefined {
    return undefined;
  }

  getValue() {
    return this.value;
  }

  /**
   * Sets filter value directly (not through constructor). Use only for existing filters.
   * The filter value has to be in a correct format of the filter,
   * some filters make some changes of their constructor input data.
   * Hence format of the constructor data input can be different from the correct filter value.
   * @param value
   */
  setValue(value) {
    this.value = value;
  }

  toString() {
    return this.property;
  }

  toComponentString() {
    this.toString();
  }
}

export default Filter;
